import { NotEmptyString } from '@/Domain/Shared'

export class FileName extends NotEmptyString {
}
